// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ivu-card{background:rgba(46,46,46,.8)}.ivu-card,.ivu-card:hover{border-color:#444}.ivu-card-head{padding:5px 10px!important}.ivu-card-body{padding:0!important}.demo-badge-alone{background:#ee7c4b!important;top:-20px;right:-5px}.demo-badge-new{background:rgba(46,46,46,.8);color:#ee7c4b}", ""]);
// Exports
module.exports = exports;
